import * as moment from "moment";

enum DateType {
  CHAT = "chat",
  MESSAGE = "message",
}

export const formatDate = (value: string | Date, type?: string): string => {
  const date = moment(value);

  if (date.isSame(new Date(), "day")) {
    return type === DateType.CHAT
      ? date.format("hh:mm A")
      : type === DateType.MESSAGE
        ? "Today"
        : `Today ${date.format("MMM DD")}`;
  }

  if (!type && moment().subtract(1, "days").isSame(date, "day")) {
    return `Yesterday ${date.format("MMM DD")}`;
  }
  const isNotCurrentYear = date.year() === moment().year();

  if (isNotCurrentYear) {
    return !type ? date.format("ddd MMM DD, yyyy") : date.format("ddd");
  }

  return date.format("ddd MMM DD");
};

export function toLocalISOString(date: Date): string {
  const offset = date.getTimezoneOffset();
  const localDate = new Date(date.getTime() - offset * 60 * 1000);
  return localDate.toISOString().slice(0, -1);
}
export function addDays(date: Date, days: number) {
  const newDate = new Date(date);
  newDate.setDate(date.getDate() + days);
  return newDate;
}
